import { getConfig } from "@jti/fe-common";

import { getIsEvo } from "../../utils";

import { ReferralApiEvo } from "./ReferralApiEvo";
import { ReferralApiLegacy } from "./ReferralApiLegacy";

export class ReferralApi {
  static init() {
    const config = getConfig();
    if (config.USE_EVO_ONLY) {
      return new ReferralApiEvo(config.EVO_DOMAIN, config.EVO_TENANT, config["X-RECAPTCHA-ID"]);
    }
    if (getIsEvo(config.REFERRAL_URL)) {
      return new ReferralApiEvo(config.REFERRAL_URL, config.REFERRAL_TOKEN, config["X-RECAPTCHA-ID"]);
    }
    return new ReferralApiLegacy(config.REFERRAL_URL, config.REFERRAL_TOKEN);
  }
}
